<template>
    <div v-loading="loading">
        <div id="printContent" class="print-zone">
            <div v-for="(item, index) in printList" :key="index">
                <div class="print-title-view">
                    <div class="print-title">供应商采购单</div>
                    <div class="company">
                        <div>单号：{{ orderCode }}</div>
                    </div>
                    <div class="company">
                        <div>单位：{{ company }}</div>
                    </div>
                </div>

                <div class="print-table-main">
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%;">客户名称</div>
                        <div class="div-table-cell" style="width: 80%">{{ item.EntpCusName }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%">联系电话</div>
                        <div class="div-table-cell" style="width: 80%"></div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 6%">序号</div>
                        <div class="div-table-cell" style="width: 16%;">汽配编码</div>
                        <div class="div-table-cell" style="width: 21%;">配件名称</div>
                        <div class="div-table-cell" style="width: 20%;">车型</div>
                        <div class="div-table-cell" style="width: 6%">数量</div>
                        <div class="div-table-cell" style="width: 6%">单位</div>
                        <div class="div-table-cell" style="width: 10%">采购价</div>
                        <div class="div-table-cell" style="width: 15%">仓位</div>
                        <div class="div-table-cell" style="width: 10%">备注</div>
                    </div>
                    <div class="div-table-row" v-for="(AP, index) in item.DetailList" :key="index">
                        <div class="div-table-cell" style="width: 6%">{{ AP.SortNum == 0 ? Number(index) + 1 : AP.SortNum }}</div>
                        <div class="div-table-cell" style="width: 16%;">{{ AP.APCode }}</div>
                        <div class="div-table-cell" style="width: 21%;">{{ AP.GoodName }}</div>
                        <div class="div-table-cell" style="width: 20%;">适用:{{ AP.AutoSerise }}</div>
                        <div class="div-table-cell" style="width: 6%">{{ AP.Count }}</div>
                        <div class="div-table-cell" style="width: 6%">{{ AP.Unit }}</div>
                        <div class="div-table-cell" style="width: 10%">{{ AP.Price }}</div>
                        <div class="div-table-cell" style="width: 15%">{{ AP.GoodsLocation }}</div>
                        <div class="div-table-cell" style="width: 10%">{{ AP.Remark }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 6%"></div>
                        <div class="div-table-cell" style="width: 16%;"></div>
                        <div class="div-table-cell" style="width: 21%;"></div>
                        <div class="div-table-cell" style="width: 20%;">总数量</div>
                        <div class="div-table-cell" style="width: 6%">{{ allNum }}</div>
                        <div class="div-table-cell" style="width: 6%">总价</div>
                        <div class="div-table-cell" style="width: 10%">{{ allPrice }}</div>
                        <div class="div-table-cell" style="width: 15%"></div>
                        <div class="div-table-cell" style="width: 10%"></div>
                    </div>
                </div>
                <div class="order-remark">
                    <div>{{ item.Remark ? '备注：' + item.Remark : '' }}</div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <el-button class="btn-primary" v-print="'#printContent'" @click="printedRecord">打印</el-button>
            <el-button @click="cancel()">关闭</el-button>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
// import JsBarcode from 'jsbarcode';
import QRCode from 'qrcode';
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: true,
            type: Boolean
        },
        printIds: {
            type: Array
        }
        //为了应对海口的未提交也可以预览的需求
    },
    data() {
        return {
            loading: true,
            allPrice: 0,
            allNum: 0,
            printList: [],
            company: this.$util.getLocalStorage('userMsg').EntpName,
            orderCode: '',
            imgUrl: '',
            isPrint: false,
        };
    },
    mounted() {
        if (this.isInit) {
            this.init();
        } else this.loading = false;
    },
    methods: {
        init() {
            this.printList=[];
            this.getOrder();
        },
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord({ OrderId: this.printIds[0].id, Type: 2 }, false)
                .then(() => {
                    this.isPrint = true;
                    this.loading = false;
                    this.closeDialog(true);
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpPurchaseOrder/GetEntpPurchaseOrderPrint',
                    data: {
                        EntpCusPOId: this.printIds[0].id,
                        EntpId: this.$util.getLocalStorage('userMsg').EntpId
                    },
                    hideLoading: this.isInit
                })
                .then(res => {
                    let _allNum = 0;
                    let _allPrice = 0;
                    let data = res.data;
                    let DetailList = data.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allPrice += DetailList[i].Count * DetailList[i].Price;
                    }
                    this.allNum = _allNum;
                    this.allPrice = _allPrice.toFixed(2) * 1;
                    this.printList.push(res.data);
                    this.orderCode = this.printIds[0].orderCode;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 64px 0 12px;
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
}
.order-detail {
    color: #000;
}
.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding: 0px 0px 15px 0px;
    color: #000;
}
.company {
    color: #000;
}
.print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-size: 28px;
    font-weight: bold;
    color: #000;
}
.dialog-footer {
    text-align: right;
}
.print-table-main {
    margin-bottom: 20px;
    font-size: 12px;
    .div-table-row {
        border-color: black;
        margin-left: 0;
    }
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 10px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
}
</style>
